<template>
  <div class="secondaryTextButton" v-html="text"></div>
</template>

<script>

  export default {
    name: 'SecondaryTextButton',
    props: ['text'],
    data() {
      return {
      }
    },
    methods: {

    },

    created() {
    }
  }
</script>

<style>


</style>
